import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { all, fork, take, call, put } from "redux-saga/effects";
import createSagaMiddleware from "redux-saga";
import userSlice from "./slices/userSlice";
import watchUser from "./saga/userSage";
import authSlice from "./slices/authSlice";
import watchAuth from "./saga/authSage";
import serviceSlice from "./slices/serviceSlice";
import watchService from "./saga/serviceSage";
import mainSlice from "./slices/mainSlice";
import watchMain from "./saga/mainSage";
import pointSlice from "./slices/pointSlice";
import watchPoint from "./saga/pointSage";
import amoSlice from "./slices/amoSlice";
import watchAmo from "./saga/amoSage";

const sagaMiddleware = createSagaMiddleware();

const rootReducer = combineReducers({
  user: userSlice.reducer,
  auth: authSlice.reducer,
  service: serviceSlice.reducer,
  main: mainSlice.reducer,
  point: pointSlice.reducer,
  amo: amoSlice.reducer,
});

function* rootSaga() {
  yield all([fork(watchUser)]);
  yield all([fork(watchAuth)]);
  yield all([fork(watchService)]);
  yield all([fork(watchMain)]);
  yield all([fork(watchPoint)]);
  yield all([fork(watchAmo)]);
}
function createStore() {
  // 여기서 store를 생성한다.
  const store = configureStore({
    reducer: rootReducer,
    middleware: [sagaMiddleware],
  });
  sagaMiddleware.run(rootSaga);
  return store;
}

const store = createStore();

// RootState type. useSelector 사용 시 state 타입을 위해 필요하다.
// export type RootState = ReturnType<typeof store.getState>

export default store;
